import { jsx as _jsx } from "react/jsx-runtime";
import { Drawer as HeroDrawer, DrawerContent as HeroDrawerContent, DrawerHeader as HeroDrawerHeader, DrawerBody as HeroDrawerBody, DrawerFooter as HeroDrawerFooter } from '@heroui/react';
export const Drawer = (props) => {
    return _jsx(HeroDrawer, { ...props });
};
export const DrawerContent = (props) => {
    return _jsx(HeroDrawerContent, { ...props });
};
export const DrawerHeader = (props) => {
    return _jsx(HeroDrawerHeader, { ...props });
};
export const DrawerBody = (props) => {
    return _jsx(HeroDrawerBody, { ...props });
};
export const DrawerFooter = (props) => {
    return _jsx(HeroDrawerFooter, { ...props });
};
export default Drawer;
//# sourceMappingURL=Drawer.js.map